var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.172 116.594L139.398 4.82845C132.966 -1.60948 122.525 -1.60948 116.084 4.82845L92.8747 28.0382L122.317 57.4808C129.16 55.1691 137.005 56.7196 142.46 62.1744C147.94 67.6629 149.479 75.5755 147.111 82.4404L175.486 110.816C182.351 108.451 190.272 109.981 195.755 115.473C203.418 123.133 203.418 135.548 195.755 143.213C188.09 150.879 175.675 150.879 168.006 143.213C162.243 137.444 160.819 128.978 163.737 121.877L137.275 95.4146L137.272 165.052C139.14 165.979 140.904 167.212 142.46 168.763C150.122 176.423 150.122 188.838 142.46 196.509C134.794 204.171 122.373 204.171 114.719 196.509C107.057 188.838 107.057 176.423 114.719 168.763C116.612 166.872 118.803 165.443 121.14 164.482V94.1956C118.803 93.2405 116.615 91.8193 114.719 89.9148C108.913 84.1173 107.517 75.598 110.492 68.4691L81.4707 39.4422L4.83056 116.077C-1.61019 122.52 -1.61019 132.961 4.83056 139.399L116.604 251.167C123.039 257.605 133.477 257.605 139.921 251.167L251.172 139.918C257.609 133.478 257.609 123.031 251.172 116.594Z",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.a0b8447eefa4cd939642f1017ee1c962.svg";
export { ForwardRef as ReactComponent };